module.exports = __webpack_public_path__ + "assets/img/title-a37c6fa1.png";